// TYPESCRIPT MAIN FILE
import "./Header.js";
import "./modules/ap-projects.ts";
import "./modules/ap-text-media.ts";

// ACCORDION BLOCKS
document.addEventListener("DOMContentLoaded", function () {
  const accordionBlocks = document.querySelectorAll(
    ".acf-block--ap-accordion .accordion-container .accordion-item",
  );

  accordionBlocks.forEach((block) => {
    const headers = block.querySelectorAll(".accordion-header");
    headers.forEach((header) => {
      header.addEventListener("click", function () {
        block.classList.toggle("active");
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionBlocks = document.querySelectorAll(
    ".component__accordion .accordion-container .accordion-item",
  );

  accordionBlocks.forEach((block) => {
    const headers = block.querySelectorAll(".accordion-header");
    headers.forEach((header) => {
      header.addEventListener("click", function () {
        block.classList.toggle("active");
      });
    });
  });
});
